import React from 'react';

import { CreateDeal } from './create_deal';

export function StandaloneTools() {
  return <>
    <CreateDeal/>
  </>;
}
